                                                                    import { Divider, Flex, Spinner, Text, VStack } from "@chakra-ui/react"
import GlucoseValues from "./GlucoseValues"
import { useGetGlucoseByRegistration } from "hooks/useGlucoseRegister"

interface Props {
    registration_number: string
    cpf: string
}

const Glucose = ({ registration_number, cpf }: Props) => {

    const { data, loading } = useGetGlucoseByRegistration(registration_number, cpf);
    const getGlucoseByRegistration = data?.getGlucose.glucose_monitoring || [];

    if (loading)
        return (<Flex w="full"><Spinner size="md" /></Flex>)

    return (
        <Flex w="full">
            <VStack gap={8} divider={<Divider />}>
                {
                    getGlucoseByRegistration.length == 0 ?
                        <Text fontSize="md">Não foram encontrados valores registrados</Text>
                        :
                        <>
                            <Text fontSize="md">Valores registrados</Text>
                            {
                                getGlucoseByRegistration.map((data: any) => <GlucoseValues {...data} />)
                            }
                        </>
                }
            </VStack>
        </Flex>
    )
}

export default Glucose